import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'

import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'
import { RolesPermissionsListWrapper } from './roles-permissions-list/RolesPermissionsList'

const rolespermissionsBreadcrumbs: Array<PageLink> = [
  {
    title: 'RolePermission Management',
    path: '/admin/pages/rolespermissions',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/rolespermissions/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const RolesPermissionsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='rolespermissions'
          index
          element={
            <>
              <PageTitle breadcrumbs={rolespermissionsBreadcrumbs}>RolesPermissions list</PageTitle>
              <RolesPermissionsListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/rolespermissions/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/rolespermissions' />} />
    </Routes>
  )
}

export default RolesPermissionsPage
